import React, { useState } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";
import { AppointmentRoutes } from "views/Appointment";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "slices/userSlice";

export function usePermissions() {
  const { user } = useSelector(userSelector);
  function checkPermission(value) {
    if (user?.role === "admin" || user?.role === "super_admin") return true;
    return !!user?.permissions?.some(i => i.name === value);
  }

  return { checkPermission };
}


function Dashboard(props) {
  const dispatch = useDispatch();
  const { user, logout } = useSelector(userSelector);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Sidebar toggle state
  const mainPanel = React.useRef();
  const location = useLocation();

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  let allowedUrls
  if (user?.permissions) {
    allowedUrls = user?.permissions?.map(i => i.url)?.filter(url => url)?.map(url => (url.startsWith("/") ? url?.slice(1) : url));
  }
  else {
    localStorage.removeItem("persist:root");
    setTimeout(() => {
      window.location.replace("/login")
    }, 200);
  }
  const filteredRoutes = routes.filter(prop => {
    const routePath = prop?.path === "" ? "dashboard" : prop?.path;
    return user?.role === "admin" || user?.role === "super_admin" || allowedUrls?.some(url => routePath.startsWith(url));
  });

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        user={user}
        allowedUrls={allowedUrls}
        routes={filteredRoutes}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        <DemoNavbar {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {filteredRoutes.map((prop, key) => (
            prop?.path !== "appointments" && (
              <Route path={prop.path} element={prop.component} key={key} />
            )
          ))}
          <Route path="/appointments/*" element={<AppointmentRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      <Outlet />
    </div>
  );
}

export default Dashboard;
